var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 20 32","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20 14h-8l6-14L0 18h8L2 32l18-18z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }